module.exports = __webpack_public_path__ + "img/zoom-in.c55b1d11.svg";